// extracted by mini-css-extract-plugin
module.exports = {"rotateLeft":"Icon_rotateLeft__Gn3qb","rotateDown":"Icon_rotateDown__3Ef_5"};